import styled from 'styled-components';
import { Title } from '../Typography';

export const StyledTitle = styled(Title)`
  margin-bottom: 24px;
`;
export const ProductWrapper = styled.div`
  margin-bottom: 32px;
  > span {
    &:after {
      display: none;
    }
  }
  a {
    color: black;
    span {
      position: relative;
      &:after {
        content: '';
        position: absolute;
        display: block;
        width: 100%;
        left: 0;
        bottom: -2px;
        border-bottom: 1px solid black;
        transition: all 0.5s;
      }
      &:hover {
        &:after {
          width: 0%;
        }
      }
    }
  }
`;
export const ProductImage = styled.div`
  height: 252px;
  background: #f7e9d5;
  border: 1px solid #efdbb2;
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 25px;
  @media (min-width: 768px) {
    width: 414px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
